const EXPOSURES = new Set(['ORGANIZATION_ONLY', 'RELDO_NETWORK'])

export function distributionCapabilities({ object, context }) {
	const membership = context?.membership
	const ownsObject = String(object?.organizationId ?? '') === String(context?.organization?.id ?? '')
	const active = membership?.status === 'ACTIVE'
	const privileged = ['OWNER', 'ADMIN'].includes(membership?.role)
	const assignedMember = membership?.role === 'MEMBER'
		&& String(object?.assigneeMembershipId ?? '') === String(membership?.id ?? '')
	return Object.freeze({ canManage: Boolean(ownsObject && active && (privileged || assignedMember)) })
}

export function normalizeExposure(value) {
	if (!EXPOSURES.has(value)) throw new TypeError('Invalid Object exposure')
	return value
}

export function safeDistributionError(error) {
	const code = error?.response?.data?.error?.code || error?.code
	return {
		OBJECT_DISTRIBUTION_FORBIDDEN: 'Недостаточно прав для изменения распространения объекта.',
		INVALID_SHARE_TARGET: 'Организация недоступна для предоставления доступа.',
		ORGANIZATION_NOT_FOUND: 'Организация больше не найдена.',
		STALE_ORGANIZATION_RESPONSE: 'Организация была переключена. Данные не применены.',
	}[code] || 'Не удалось сохранить настройки распространения объекта.'
}

export function sharePresentation(target) {
	if (!target || !['PERSONAL', 'TEAM'].includes(target.kind) || !/^[1-9]\d{11}$/.test(String(target.reldoId || ''))) return null
	return target.kind === 'PERSONAL'
		? Object.freeze({ kind: 'PERSONAL', reldoId: target.reldoId, name: target.professional?.displayName || target.systemLabelKey || 'Личная организация', title: target.professional?.title || null, avatarObjectKey: target.professional?.avatarObjectKey || null })
		: Object.freeze({ kind: 'TEAM', reldoId: target.reldoId, name: target.name || 'Организация', logoObjectKey: target.logoObjectKey || null })
}
